import { render, staticRenderFns } from "./MenuSuperior.vue?vue&type=template&id=179622a6&scoped=true&lang=pug"
import script from "./MenuSuperior.vue?vue&type=script&lang=js"
export * from "./MenuSuperior.vue?vue&type=script&lang=js"
import style0 from "./MenuSuperior.vue?vue&type=style&index=0&id=179622a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179622a6",
  null
  
)

export default component.exports